import "./style.css";
import Header from "../../../componente/header";
import api from "../../../services/api";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import LoadingScreen from "../../../componente/aguarde";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";

function GerarFicha() {
  const [loading, setLoading] = useState(false);

  const dt = new Date();

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    "01";

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [abusca, setabusca] = useState("");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [listaficha, setlistaficha] = useState([]);
  const [listaviagem, setlistaviagem] = useState([]);
  const [listakit, setlistakit] = useState([]);

  const [showform, setshowform] = useState(false);
  const [excluido, setexcluido] = useState(false);

  const [qtdeficha, setqtdeficha] = useState(0);
  const [codkit, setcodkit] = useState(0);
  const [codviagem, setcodviagem] = useState(0);
  const [qtdeitens, setqtdeitens] = useState(0);
  const [valor, setvalor] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setcodviagem(cad.codviagem);
    setcodkit(cad.codkit);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      ExcluirCad();
      setIsOpenMotivoExclusao(false);
      ListarFicha();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarFicha() {
    api
      .get("/v1/operacoes/ficha", {
        params: {
          busca: abusca,
          dt1,
          dt2,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistaficha(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarFicha();
  }, [showform, abusca, dt1, dt2, excluido]);

  function ListarViagem() {
    api
      .get("/v1/operacoes/viagem", {
        params: {
          busca: "",
          dt1: "",
          dt2: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistaviagem(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarViagem();
  }, [showform]);

  function ListarKit() {
    api
      .get("v1/cadastro/kit", {
        params: {
          busca: "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlistakit(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarKit();
  }, [showform]);

  function Cadastrar() {
    setLoading(true);

    api
      .post(
        "v1/operacoes/ficha",
        {
          ficha: qtdeficha,
          qtdeitens,
          valor,
          excluido: "N",
          codempresa: localStorage.getItem("tempCodEmpresa"),
          codusuario: localStorage.getItem("tempCodUsuario"),
          codkit,
          codviagem,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowform(false);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      })
      .finally(() => {
        setLoading(false);
      });;
  }

  function closeModal() {
    setshowform(false);
  }

  function Salvar() {
    if (codviagem === 0) {
      alert("Informe a Viagem");
    } else if (codkit === 0) {
      alert("Informe o Kit");
    } else if (qtdeficha === 0) {
      alert("Informe a Qtde de Fichas");
    } else {
      Cadastrar();
    }
  }

  function Novo() {
    setcodviagem(0);
    setcodkit(0);
    setqtdeficha(0);
    setqtdeitens(0);
    setvalor(0);

    setshowform(true);
  }

  function ExcluirCad() {
    api
      .delete("/v1/operacoes/ficha", {
        params: {
          codviagem: codviagem,
          codkit: codkit,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setexcluido(true);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function InformarDados(k) {
    setqtdeitens(k.qtdeitens);
    setvalor(k.valor);
  }

  return (
    <>
      <Header />

      <div>
        <div>
          <PopUp isOpen={isOpen} onClose={handleClose}>
            <h2>Verificação</h2>
            <p>Tem certeza que deseja excluir esse registro?</p>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleConfirma}
                >
                  Sim
                </button>
                <button className="btn btn-danger" onClick={handleClose}>
                  Não
                </button>
              </div>
            </div>
          </PopUp>
        </div>

        <div>
          <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
            <h2>Antes de Excluir</h2>
            <p>Informe qual o motivo da exclusão?</p>

            <div className="col-sm-12">
              <label htmlFor="motivo" className="form-label">
                Motivo
              </label>
              <input
                type="text"
                id="motivo"
                className="form-control"
                placeholder="Descreva aqui"
                value={edtMotivo}
                onChange={(e) => setEdtMotivo(e.target.value)}
              />
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleInformarMotivoExclusao}
                >
                  Informar
                </button>
                <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                  Cancelar
                </button>
              </div>
            </div>
          </PopUpMotivoExclusao>
        </div>

        <Modal
          isOpen={showform}
          onRequestClose={closeModal}
          overlayClassName="modal-overlay"
          className="modal-content modal-xl"
        >
          <div className="container-fluid h-100">
            <div className="row">
              <h2>Novo Lançamento</h2>
            </div>
            <div className="row">
              <hr />
            </div>

            <div className="row">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="viagem" className="form-label">
                      Viagem
                    </label>
                    <select
                      id="viagem"
                      className="form-select"
                      value={codviagem}
                      onChange={(e) => setcodviagem(e.target.value)}
                    >
                      <option value="0">Escolha a Viagem</option>
                      {listaviagem.map(function (via) {
                        return (
                          <option key={via.codviagem} value={via.codviagem}>
                            {via.local}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="qtdeficha" className="form-label">
                      Qtde Ficha
                    </label>
                    <input
                      type="text"
                      id="qtdeficha"
                      className="form-control"
                      value={qtdeficha}
                      onChange={(e) => setqtdeficha(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <label htmlFor="kit" className="form-label">
                      Kit
                    </label>
                    <select
                      id="kit"
                      className="form-select"
                      value={codkit}
                      onChange={(e) => {
                        setcodkit(e.target.value);
                        InformarDados(listakit[e.target.value - 1]);
                      }}
                    >
                      <option value="0">Escolha o Kit</option>
                      {listakit.map((k) => {
                        return (
                          <option key={k.codkit} value={k.codkit}>
                            {k.descricao} - Qtde Itens: {k.qtdeitens} - Valor:{" "}
                            {k.valor}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="qtdeitens" className="form-label">
                      Qtde Itens
                    </label>
                    <input
                      type="text"
                      id="qtdeitens"
                      className="form-control"
                      value={qtdeitens}
                      readOnly
                    />
                  </div>

                  <div className="col-sm-3">
                    <label htmlFor="valorkit" className="form-label">
                      Valor do Kit
                    </label>
                    <input
                      readOnly
                      type="text"
                      id="valorkit"
                      className="form-control"
                      value={valor}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="row">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-danger ms-4" onClick={closeModal}>
                  Cancelar
                </button>
                <button className="btn btn-success ms-4" onClick={Salvar}>
                  Salvar
                </button>
                {loading && <LoadingScreen />}
              </div>
            </div>
          </div>
        </Modal>
      </div>

      <div className="row">
        <h1 className="ms-4">Gerar Fichas</h1>

        <p className="ms-4">
          Rotina para gerar as fichas que serão utilizadas na rota para vincular
          as clientes.
        </p>
        <hr />
      </div>

      <div className="row ps-2 pe-2">
        <div className="col-sm-6">
          <label className="form-label form-check-label" htmlFor="busca">
            Busque aqui
          </label>
          <input
            type="text"
            placeholder="Buscar por: Código ou Local"
            name="busca"
            id="busca"
            className="form-control me-3"
            value={abusca}
            onChange={(e) => setabusca(e.target.value)}
          />
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            Lançamento de...
          </label>
          <br />
          <input
            type="date"
            id="periodo"
            className="form-control"
            placeholder="Data Inicio"
            value={dt1}
            onChange={(e) => setdt1(e.target.value)}
          />
        </div>

        <div className="col-sm-2">
          <label htmlFor="periodo" className="form-label">
            Para...
          </label>
          <br />
          <input
            type="date"
            id="periodo2"
            className="form-control"
            placeholder="dtnascimento"
            value={dt2}
            onChange={(e) => setdt2(e.target.value)}
          />
        </div>

        <div className="col-sm-2 d-flex justify-content-center">
          <button className="btn btn-success btnnovo" onClick={(e) => Novo()}>
            Novo
          </button>
        </div>
      </div>

      <div className="row mt-3">
        <hr />
      </div>

      <table className="table table-hover fonte">
        <thead>
          <tr>
            <th className="codigo">Código</th>
            <th className="lancamento">Local</th>
            <th className="dtinicio">Qtde Ficha</th>
            <th className="dtfim">Valor Total</th>
            <th className="local">Cód. Kit</th>
            <th className="local">Kit</th>
            <th className="acoes">Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaficha.map(function (item) {
            return (
              <tr key={item}>
                <th>{item.codviagem}</th>
                <th>{item.local}</th>
                <th>{item.qtdeficha}</th>
                <th>{item.valortotal}</th>
                <th>{item.codkit}</th>
                <th>{item.kit}</th>
                <th>
                  <div className="d-flex justify-content-center">
                    <button
                      className="btn fa-solid fa-trash"
                      onClick={() => handleOpen(item)}
                    ></button>
                  </div>
                </th>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th colSpan={7}>Quantidade de Registros: {listaficha.length}</th>
          </tr>
        </tfoot>
      </table>
    </>
  );
}

export default GerarFicha;
